import { useEffect, useRef, useState } from "react";

export default function LimitText({ children, lineLimit = [5, 10, 16], class_container = "", style_container = { none: 'none' }, extra_code }) {
    const textRef = useRef(null);
    const [isClamped, setIsClamped] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const [lines, setLines] = useState(3); // valor inicial

    function escapeHTML(str) {
        return str
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#039;");
    }

    function resetText(texto) {
        let text = escapeHTML(String(texto));

        text = text.replace(/\*\*(.*?)\*\*/g, '&#42;<b>$1</b>&#42;');
        text = text.replace(/(^|[^*])\*(?!\*)([^*]+)\*(?!\*)([^*]|$)/g, '$1<b>$2</b>$3');
        text = text.replace(/(^|[^*])\*(?!\*)([^*]+)\*(?!\*)([^*]|$)/g, '$1<b>$2</b>$3');
        text = text.replace(/(https?:\/\/[^\s]+)/g, (url) => {
            return `<a href="${url}" target="_blank">${url}</a>`;
        });

        return text;
    }

    // 🧠 Detectar el ancho de pantalla y ajustar cantidad de líneas
    useEffect(() => {
        const updateLines = () => {
            if (window.matchMedia("(max-width: 600px)").matches) {
                setLines(lineLimit[0]); // Celular
            } else if (window.matchMedia("(max-width: 1024px)").matches) {
                setLines(lineLimit[1]); // Tablet
            } else {
                setLines(lineLimit[2]); // PC
            }
        };

        updateLines();

        window.addEventListener("resize", updateLines);
        return () => window.removeEventListener("resize", updateLines);
    }, []);

    // 🧩 Verificar si el texto está truncado
    useEffect(() => {
        const el = textRef.current;
        if (!el) return;

        const checkClamp = () => {
            setIsClamped(el.scrollHeight > el.clientHeight);
        };

        checkClamp();

        const observer = new ResizeObserver(checkClamp);
        observer.observe(el);
        return () => observer.disconnect();
    }, [children, lines]);

    return (
        <div className={class_container} style={style_container}>
            {
                extra_code
            }
            <p
                ref={textRef}
                className={`limit-lines-text ${expanded ? "expanded" : ""}`}
                style={{
                    WebkitLineClamp: expanded ? "unset" : lines,
                }}

                dangerouslySetInnerHTML={{
                    __html: typeof children === "string" ? resetText(children) : children,
                }}
            />
            {((isClamped && !expanded) || expanded) && (
                <button
                    className="default-buttons"
                    style={{ height: 'min-content', color: 'var(--empresa-color)' }}
                    onClick={() => setExpanded((prev) => !prev)}
                >
                    {expanded ? "Mostrar menos" : "Mostrar más"}
                </button>
            )}
        </div>
    );
}
